<div class="w-100 h-100">
    <div class="row" style="padding-top: 25px;">
        <div class="col-md-12">
            <div class="form-row justify-content-between align-items-baseline">
                <div class="col-auto">
                    <label class="header_text mb-3">
                        {{$t('shared.addRequest')}}
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="row justify-content-sm-center">
        <div class="col-sm-12">
            <v-stepper alt-labels :value="stepNumber">
                <v-stepper-header>
                    <v-stepper-step step="1"
                                    :class="['stepper-label-nowrap', { 'complete': stepNumber > 1 }]">
                                    {{$t('shared.entityInfo')}}</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="2"
                                    :class="['stepper-label-nowrap', { 'complete': stepNumber > 2 }]">
                                    {{$t('shared.senderInfo')}}</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="3" :class="['stepper-label-nowrap', { 'complete': stepNumber > 3 }]">
                        {{$t('shared.representativeInfo')}}
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="4"
                                    :class="['stepper-label-nowrap', { 'complete': stepNumber > 4 }]">
                                    {{$t('shared.attachments')}}</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="5" v-if="model.customerType !== 4"
                        :class="['stepper-label-nowrap', {'complete': stepNumber > 5}]">
                        {{$t('shared.aiAttachmentReview')}}
                    </v-stepper-step>
                    <v-divider v-if="model.customerType !== 4"></v-divider>
                    <v-stepper-step v-if="model.customerType === 4" step="5"
                        :class="['stepper-label-nowrap', { 'complete': stepNumber > 6 }]"> {{$t('shared.review')}} </v-stepper-step>
                    <v-stepper-step v-if="model.customerType !== 4" step="6"
                        :class="['stepper-label-nowrap', { 'complete': stepNumber > 6 }]"> {{$t('shared.review')}} </v-stepper-step>
                </v-stepper-header>
            </v-stepper>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card card_layout">
                                <div class="card-body card_body_layout" v-if="stepNumber == 7">
                    <div class="d-flex flex-column align-items-center justify-content-center" style="min-height:300px;">
                        <img class="pb-4" :src="require('../img/BigCheck.svg')" style="width: 120px;" />
                        <label class="w-100 pb-4 text-center" style="font-size: 1.4rem;">
                            {{$t('shared.requestSubmittedSuccessfully')}}
                        </label>
                        <div class="form-row justify-content-center align-items-center mt-3">
                            <div class="col-auto mx-3">
                                <router-link to="/Dashboard" tag="button"
                                            class="btn btn-outline-primary px-5 py-2 mx-2">
                                    {{$t('shared.requestsListPage')}}
                                </router-link>
                            </div>
                            <div class="col-auto mx-3">
                                <button class="btn btn-primary px-5 py-2"
                                        @click="newRequest()">
                                    {{$t('shared.newRequest')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body card_body_layout" v-show="stepNumber == 1">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row align-items-end">
                                <div class="col-md-4 mb-3">
                                    <div class="form-group mb-0">
                                        <label>{{$t('shared.customerType')}}</label>
                                        <v-select v-model="model.customerType" :items="customerTypeList" :label="$t('shared.select')"
                                            item-text="name" item-value="id" solo attach
                                            :disabled="provider.isVirtualOperator">
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3" v-if="model.customerType === 3">
                                    <div class="form-group mb-0">
                                        <label>{{$t('shared.validationType')}}</label>
                                        <div>
                                            <input type="radio" id="1" :value="1" :disabled="verifyCounter == 3 || provider.isVirtualOperator"
                                                v-model="model.verificationType" @click="clearDataOnChageVaidationType" />
                                            <label for="1" style="padding: 10px;">{{$t('shared.auto')}}</label>
                                            <input type="radio" id="0" :value="0" v-model="model.verificationType"
                                                @click="clearDataOnChageVaidationType"
                                                :disabled="provider.isVirtualOperator" />
                                            <label for="0" style="padding: 10px;">{{$t('shared.manual')}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4 mb-3">
                                    <div class="form-group">
                                        <label>{{$t('shared.clientName')}}</label>
                                        <input class="form-control" v-model="model.clientName" type="text"
                                            :disabled="model.verificationType == 1 || provider.isVirtualOperator" />
                                        <small v-if="model.customerType === 3 && model.verificationType == 1" class="helper-text"
                                            style="font-weight: bold;">
                                            {{$t('shared.ensureClientName')}}
                                        </small>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3" v-if="model.customerType !== 0 && model.customerType !== 3">
                                    <div class="form-group">
                                        <label v-if="model.customerType === 1">{{$t('shared.budgetNumber')}}</label>
                                        <label v-if="model.customerType === 2">{{$t('shared.licenseNumber')}}</label>
                                        <label
                                            v-if="model.customerType === 4">{{$t('shared.internationalCommercialRegistrationNumber')}}</label>
                                        <input class="form-control" v-model="model.crNumber" type="text"
                                            :disabled="model.verificationType == 1" />
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3" v-if="model.customerType === 2 || model.customerType === 3">
                                    <div class="form-group">
                                        <label>{{$t('shared.enterpriseUnifiedNumber')}}</label>
                                        <input :class="['form-control', { 'is-invalid': enterpriseUnifiedNumberError }]"
                                            v-model="model.enterpriseUnifiedNumber" type="text"
                                            :disabled="provider.isVirtualOperator" />
                                        <div class="invalid-feedback" v-if="enterpriseUnifiedNumberError">
                                            {{ enterpriseUnifiedNumberError }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body card_body_layout" v-if="stepNumber == 2">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-2 mb-3">
                                <div class="form-group">
                                    <label>{{$t('shared.durationYear')}}</label>
                                    <input class="form-control" @paste="isNumberFieldPaste($event)" v-model="model.duration"
                                        @keypress="isNumberField($event)" :disabled="true" type="text" />
                                </div>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label" style="font-weight: 500;">
                                    {{ $t('shared.contractExpiryDate') }}
                                </label>
                                <div class="input-group mb-3 expiry-date-wrapper">
                                    <v-menu v-model="expiryDateFromMenu" :close-on-content-click="false" transition="scale-transition"
                                        offset-y attach=".expiry-date-wrapper" content-class="expiry-date-menu">
                                        <template v-slot:activator="{ on, attrs }">
                                            <div class="input-group mb-3 flex-nowrap">
                                                <input class="form-control border-right-0 border-left w-100" v-model="model.expiryDate"
                                                    readonly v-bind="attrs" ref="expiryDatePicker" v-on="on" type="text"
                                                    style="min-width: 0;" />
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text right gray">
                                                        <i class="far fa-calendar-alt"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </template>
                                        <v-date-picker v-model="model.expiryDate" no-title scrollable :min="currentDate"
                                            @input="expiryDateFromMenu = false">
                                        </v-date-picker>
                                    </v-menu>
                                </div>
                            </div>              
                            <div class="col-md-2 pr-md-0">
                                <label class="d-inline-flex align-items-center" style="gap:4px">
                                    {{$t('shared.connectivityAdding')}}
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on" :style="{ color: 'var(--color-Main)' }">
                                                mdi-information-outline
                                            </v-icon>
                                        </template>
                                        <span>{{$t('shared.autoActivationNote')}}</span>
                                    </v-tooltip>
                                </label>
                                <div class="form-group">
                                    <input type="radio" id="autoActivation-true" name="autoActivation" :value="true"
                                        v-model="model.isAutoActivation" @click="show()" />
                                    <label for="autoActivation-true" style="padding: 10px;">{{$t('shared.auto')}}</label>
                                    <input type="radio" id="autoActivation-false" name="autoActivation" :value="false"
                                        v-model="model.isAutoActivation" @click="hide()" />
                                    <label for="autoActivation-false" style="padding: 10px;">{{$t('shared.manual')}}</label>
                                </div>
                            </div>                
                            <div class="col-md-4 pr-md-0" v-if="showOperators">
                                <div class="form-group">
                                    <label>{{$t('shared.Operator')}}</label>
                                    <v-select v-model="model.operators" :items="connectivityOperatorList" multiple chips
                                        :label="$t('shared.select')" solo attach :disabled="virtualOperatorConnectivityLocked">
                                    </v-select>
                                </div>
                            </div>
                        </div>            
                        <div class="row">
                            <div class="col-md-6">
                                <div class="row">
                                           
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>{{$t('shared.sendersList')}}</label>
                                            <v-select v-model="senderType" :items="senderTypeList" item-text="name" item-value="id"
                                                multiple :label="$t('shared.select')" solo attach style="min-height: 46px;">
                                            </v-select>
                                        </div>
                                    </div>               
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>{{$t('shared.sendersName')}}</label>
                                            <div class="input-group">
                                                <input class="form-control border-right-0 border-left"
                                                    @paste="isSenderNameFieldPaste($event)" @keypress="isSenderNameField($event)"
                                                    :maxlength="senderNameLength" v-model="senderName" @input="onInputChange"
                                                    type="text" :disabled="isSenderTypeEmpty" :title="senderNameTitle"
                                                    :style="senderNameInputStyle" />
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text right" style="padding: 2px 2px 0px 2px !important;">
                                                        <button class="btn btn-primary" @click="AddSender"
                                                            :disabled="!isValidSenderName" :title="senderNameTitle"
                                                            :style="addSenderButtonStyle">
                                                            <i class="fas fa-plus"></i>
                                                        </button>
                                                        <button class="btn btn-primary" @click="suggest" :disabled="isSuggestDisabled"
                                                            :title="$t('shared.senderSuggestionTooltip')">
                                                            <i class="fas fa-share-alt"></i>
                                                        </button>
                                                    </span>
                                                </div>
                                            </div>
                                            <span v-if="senderNameError" style="color: #E53935; font-size: 13px;">{{ senderNameError
                                                }}</span>
                                            <span v-if="senderNameSymbolError"
                                                style="color: #E53935; font-size: 13px; display: block;">{{ senderNameSymbolError
                                                }}</span>
                                        </div>
                                    </div>               
                                    <div class="col-md-12">
                                        <ul v-if="model.senderNames.length > 0" class="list-group list_Sender scrollbar"
                                            style="width: 100%; font-size: 16px;">
                                            <li class="list-group-item" v-for="(item, index) in model.senderNames" :key="index"
                                                style="padding-top: 0.75rem; padding-bottom: 0.75rem;">
                                                <div class="d-flex align-items-center justify-content-between" style="gap: 8px;">
                                                    <div>
                                                        <label class="box-name mb-0">{{ item.senderName }}</label>
                                                    </div>
                                                    <i class="far fa-trash-alt Icon_delete"
                                                        style="margin-left: 8px; flex-shrink: 0;"
                                                        @click="deleteSender(index)"></i>
                                                </div>
                                                <div v-if="domainRequired(item.senderName)">
                                                    <input class="form-control bg-white text-dark" v-model="item.domainName" type="text"
                                                        :placeholder="$t('shared.domainName')" />
                                                </div>
                                            </li>
                                        </ul>
                                        <ul v-else class="list-group list_Sender scrollbar" style="width: 100%; font-size: 14px;">
                                            <li class="list-group-item">
                                                {{$t('shared.noSenderNames')}}
                                            </li>
                                        </ul>
                                        <div v-if="shouldShowDomain" class="mt-1">
                                            <small class="text-muted">
                                                {{$t('shared.domainHelperTextPrefix')}}<br>
                                                <a href="https://nic.sa/registrars/" target="_blank">
                                                    {{$t('shared.domainHelperTextLink')}}
                                                </a>
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>               
                            <div class="col-md-2 pr-md-0">
                                <label class="d-inline-flex align-items-center" style="gap:4px">
                                    {{$t('shared.payment')}}
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on" :style="{ color: 'var(--color-Main)' }">
                                                mdi-information-outline
                                            </v-icon>
                                        </template>
                                        <span>{{$t('shared.paymentAutoDeductNote')}}</span>
                                    </v-tooltip>
                                </label>
                                <div class="form-group">
                                    <input type="radio" id="autoPaid-true" name="autoPaid" :value="true" v-model="model.isAutoPaid" />
                                    <label for="autoPaid-true" style="padding: 10px;">{{$t('shared.auto')}}</label>
                                    <input type="radio" id="autoPaid-false" name="autoPaid" :value="false" v-model="model.isAutoPaid" />
                                    <label for="autoPaid-false" style="padding: 10px;">{{$t('shared.manual')}}</label>
                                </div>
                            </div>               
                            <div class="col-md-4" v-if="showSuggestions">
                                <div class="form-group">
                                    <label>{{$t('shared.suggestedSenderNames')}}</label>
                                    <v-select v-model="selectedSuggestedSenderName" :items="suggestedSenderNamesList" label="Select"
                                        solo @change="updateSenderName" attach />
                                </div>
                            </div>
                        </div>              
                        <div class="row mt-3" v-if="model.customerType === 2 || model.customerType === 3">
                            <div class="col-md-12">
                                <v-checkbox v-model="model.hasTrademark" :label="$t('shared.iHaveTrademark')">
                                </v-checkbox>
                            </div>
                
                            <div class="col-md-3 mb-3" v-if="model.hasTrademark">
                                <div class="form-group">
                                    <label>{{ $t('shared.trademarkName')}}</label>
                                    <input class="form-control" v-model="model.trademarkName" type="text" />
                                </div>
                            </div>
                
                            <div class="col-md-3 mb-3" v-if="model.hasTrademark">
                                <label class="form-label">{{ $t('shared.protectionDateFrom') }}</label>
                                <div class="input-group mb-3">
                                    <v-menu v-model="protectionFromMenu" :close-on-content-click="false" transition="scale-transition"
                                        offset-y attach>
                                        <template v-slot:activator="{ on, attrs }">
                                            <div class="input-group mb-3 flex-nowrap">
                                                <input class="form-control border-right-0 border-left w-100"
                                                    v-model="model.protectionDateFrom" readonly v-bind="attrs" v-on="on" type="text"
                                                    style="min-width: 0;" />
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text right gray"><i class="far fa-calendar-alt"></i></span>
                                                </div>
                                            </div>
                                        </template>
                                        <v-date-picker v-model="model.protectionDateFrom" no-title scrollable
                                            @input="protectionFromMenu = false"></v-date-picker>
                                    </v-menu>
                                </div>
                            </div>                
                            <div class="col-md-3 mb-3" v-if="model.hasTrademark">
                                <label class="form-label">{{ $t('shared.protectionDateTo') }}</label>
                                <div class="input-group mb-3">
                                    <v-menu v-model="protectionToMenu" :close-on-content-click="false" transition="scale-transition"
                                        offset-y attach>
                                        <template v-slot:activator="{ on, attrs }">
                                            <div class="input-group mb-3 flex-nowrap">
                                                <input class="form-control border-right-0 border-left w-100"
                                                    v-model="model.protectionDateTo" readonly v-bind="attrs" v-on="on" type="text"
                                                    style="min-width: 0;" />
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text right gray"><i class="far fa-calendar-alt"></i></span>
                                                </div>
                                            </div>
                                        </template>
                                        <v-date-picker v-model="model.protectionDateTo" no-title scrollable
                                            @input="protectionToMenu = false"></v-date-picker>
                                    </v-menu>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body card_body_layout" v-if="stepNumber == 3">
                    <div class="row">
                        <div class="col-md-4 mb-3">
                            <div class="form-group">
                                <label>{{$t('shared.commercialRegistrationManager')}}</label>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on"
                                            :style="{ color: 'var(--color-Main)', 'margin-left': '4px' }">mdi-information-outline</v-icon>
                                    </template>
                                    <span>{{$t('shared.representativeNameTooltip')}}</span>
                                </v-tooltip>
                                <input class="form-control" v-model="model.representativeName" type="text"
                                       v-if="model.verificationType == 0" />
                                <v-select v-if="model.verificationType == 1" v-model="managerId" :items="managerList"
                                          :label="selectedManager" item-text="maskedName" item-value="value"
                                          @change="onManagerChange" solo attach>
                                </v-select>
                            </div>
                        </div>
                        <div class="col-md-4 mb-3">
                            <div class="form-group">
                                <label>
                                    {{$t('shared.representativeEmail')}}
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on" :style="{ color: 'var(--color-Main)' }">
                                                mdi-information-outline
                                            </v-icon>
                                        </template>
                                        <span>{{$t('shared.notificationEmail')}}</span>
                                    </v-tooltip>
                                </label>
                                <input :class="['form-control', { 'is-invalid': representativeEmailError }]"
                                       v-model="model.representativeEmail"
                                       type="text" />

                                <div class="invalid-feedback" v-if="representativeEmailError">
                                    {{ representativeEmailError }}
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 mb-3">
                            <div class="form-group">
                                <label>
                                    {{$t('shared.representativePhoneNumber')}}
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on" :style="{ color: 'var(--color-Main)' }">mdi-information-outline</v-icon>
                                        </template>
                                        <span>{{$t('shared.notificationPhone')}}</span>
                                    </v-tooltip>
                                </label>

                                <!-- For customer types 0–3 -->
                                <div v-if="model.customerType === 0 || model.customerType === 1 || model.customerType === 2 || model.customerType === 3"
                                     class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text gray">+966</span>
                                    </div>
                                    <input :class="['form-control border-left-0', { 'is-invalid': representativeMobileError }]"
                                           v-model="model.representativeMobile"
                                           @paste="isNumberFieldPaste($event)"
                                           @keypress="isNumberField($event)"
                                           maxlength="9"
                                           type="text" />
                                </div>

                                <!-- For customer type 4 -->
                                <div v-if="model.customerType === 4" class="input-group mb-3">
                                    <input :class="['form-control border-left-0', { 'is-invalid': representativeMobileError }]"
                                           v-model="model.representativeMobile"
                                           @paste="isNumberFieldPaste($event)"
                                           @keypress="isNumberField($event)"
                                           maxlength="9"
                                           type="text" />
                                </div>

                                <!-- Error message display -->
                                <div v-if="representativeMobileError" class="invalid-feedback d-block">
                                    {{ representativeMobileError }}
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 mb-3" v-if="model.verificationType == 1">
                            <div class="form-group">
                                <label>{{$t('shared.managerID')}}</label>
                                <input :class="['form-control', { 'is-invalid': representativeIdError }]"
                                       v-model="model.representativeIdNumber"
                                       type="text" />
                                <div class="invalid-feedback" v-if="representativeIdError">
                                    {{ representativeIdError }}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="card-body card_body_layout" v-if="stepNumber == 4">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-8 col-10">
                                    <div class="form-group">
                                        <label>{{$t('shared.comment')}}</label>
                                        <input class="form-control" v-model="model.comment" type="text" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-5 pt-3">
                                    <div class="form-group">
                                        <div class="input-group mb-3 ">
                                            <input type="file" ref="fileName" hidden
                                                   accept=".png, .jpg, .jpeg, .pdf" @change="onFilePicked">
                                            <input :placeholder="$t('shared.addAttachment')" @click="onPickFile"
                                                   class="form-control border-right-0 border-left" readonly
                                                   style="cursor: pointer;"
                                                   v-model="selectedFileName" type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 pt-3 ">
                                    <div class="form-group">
                                        <v-select v-model="attachmentType" :items="attachmentCategoryList"
                                                  :label="$t('shared.addCategory')" item-text="name" item-value="id" solo attach>
                                        </v-select>
                                    </div>
                                </div>
                                <div class="input-group-prepend pt-3">
                                    <span style="padding: 4px 4px 4px 4px !important;">
                                        <button :disabled="!canAddAttachment" @click="addAttachment"
                                                class="btn btn-primary">
                                            {{$t('shared.add')}}
                                        </button>
                                    </span>
                                </div>
                                <div class="col-md-12">
                                    <label class="d-inline-flex align-items-center" style="justify-content:flex-start; gap:4px">
                                        {{$t('shared.attachment')}}
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-bind="attrs" v-on="on" class="align-middle" :style="{ color: 'var(--color-Main)' }">
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span style="white-space: pre-line">{{ attachmentTooltip }}</span>
                                        </v-tooltip>
                                    </label>
                                    <ul class="list-group list_Sender scrollbar">
                                        <li class="list-group-item" v-if="model.senderRequestAttachments.length > 0"
                                            v-for="(item, index) in model.senderRequestAttachments" :key="item">
                                            <lable class="box-name">{{item.fileName}}</lable>
                                            <lable class="box-name">{{item.attachmentTypeName}}</lable>
                                            <i class="far fa-trash-alt Icon_delete"
                                               @click="deleteAttachment(index)"></i>
                                        </li>
                                        <li class="list-group-item" v-if="model.senderRequestAttachments.length == 0">
                                            {{$t('shared.noAttachments')}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body card_body_layout" v-if="stepNumber === 5 && model.customerType !== 4">
                    <v-container v-if="loadingAIReview" style="height: 400px;" class="d-flex align-center justify-center">
                        <v-col cols="12" class="d-flex flex-column align-center justify-center">
                            <div class="text-h2 mb-2 text-center">
                                {{ $t('shared.loadingAIReview') }}
                            </div>
                            <div class="progress-wrapper" style="position: relative; width: 100%; max-width: 800px;">
                                <v-progress-linear rounded height="25" indeterminate color="grey darken-3"
                                    class="my-outline-progress"></v-progress-linear>
                                <div class="progress-center-text">
                                    <strong>{{ Math.ceil(aiReviewProgress) }}%</strong>
                                </div>
                            </div>
                        </v-col>
                    </v-container>

                    <div v-else>
                        <div v-if="aiUnavailable" class="ai-note-alert mb-3">
                            <v-icon left color="orange darken-2" size="28" class="ai-note-icon">mdi-alert-circle</v-icon>
                            <div class="ai-note-text">
                                <strong>{{ $t('shared.note') }}</strong>
                                {{ $t('shared.aiUnavailableProceed') }}
                            </div>
                        </div>
                        <div v-if="!aiUnavailable && invalidAttachmentNote" class="ai-note-alert mb-3">
                            <v-icon left color="orange darken-2" size="28" class="ai-note-icon">mdi-alert-circle</v-icon>
                            <div class="ai-note-text">
                                <strong>{{ $t('shared.note') }}</strong>
                                {{ invalidAttachmentNote }}
                            </div>
                        </div>
                        <v-data-table v-if="!aiUnavailable" :headers="aiReviewHeaders" :items="aiReviewRows" hide-actions disable-hover class="elevation-2 review-table">
                            <template v-slot:items="props">
                                <tr v-if="!(props.item.fieldKey === 'authorized_id' && model.verificationType !== 1)">
                                    <td class="text-center"
                                        style="font-weight: 600; border-right: 1px solid #dcdcdc;">
                                        {{ props.item.fieldName }}
                                    </td>
                                    <td class="text-center" style="border-right: 1px solid #dcdcdc;">
                                        <template
                                            v-if="props.item.fieldKey === 'authorized_name_to_use' && model.customerType === 3 && model.verificationType === 1">
                                            {{ getMaskedManagerName(props.item.providerInput || '') }}
                                        </template>
                                        <template v-else>
                                            {{ props.item.providerInput }}
                                        </template>
                                    </td>
                                    <td class="text-center" style="border-right: 1px solid #dcdcdc;">
                                        {{ props.item.aiResult }}
                                    </td>
                                    <td class="text-center">
                                        <v-chip small outlined class="status-chip" :color="statusChipColor(props.item.status)"
                                            :text-color="statusTextColor(props.item.status)">
                                            {{ statusLabel(props.item.status) }}
                                            <v-icon right small :color="statusIconColor(props.item.status)">
                                                {{ statusIcon(props.item.status) }}
                                            </v-icon>
                                        </v-chip>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                        <div class="stamp-card elevation-2 mt-3" v-if="!aiUnavailable">
                            <div class="card-header enhanced-card-header">
                                <span>{{ $t('shared.stampVerification') }}</span>
                            </div>
                            <div class="card-body">
                                <div class="d-flex flex-wrap justify-content-center stamp-list">
                                    <div v-for="stamp in stampList" :key="stamp.key" class="stamp-chip align-items-center">
                                        <span class="stamp-icon"
                                            :class="stampValidation && stampValidation[stamp.prop] ? 'stamp-success' : 'stamp-error'">
                                            <v-icon size="20" :color="stampValidation && stampValidation[stamp.prop] ? 'green' : 'red'">
                                                {{ stampValidation && stampValidation[stamp.prop] ? 'mdi-check-circle' : 'mdi-close-circle' }}
                                            </v-icon>
                                        </span>
                                        <span class="stamp-title">{{ $t(`shared.${stamp.key}`) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="!aiUnavailable && !invalidAttachmentNote" class="ai-note-alert mt-4 mb-1">
                            <v-icon left color="orange darken-2" size="28" class="ai-note-icon">mdi-alert-circle</v-icon>
                            <div class="ai-note-text">
                                <strong>{{$t('shared.note')}}</strong>
                                {{$t('shared.aiAttachmentnote')}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body card_body_layout" v-if="stepNumber == 6">
                    <div v-if="model.verificationType == 1" class="row" style="margin-bottom: 25px;">
                        <i class="fas fa-check-circle fa-lg"
                           style="color: #1bb148;font-size:30px;padding-bottom: 10px;"></i>
                        <label class="user_info_header mb-0">{{$t('shared.autoVerificationCompletedSuccessfully')}}</label>
                    </div>
                    <div class="row">
                        <div class="col-md-3 mb-3">
                            <label class="user_info_header mb-0">{{$t('shared.clientName')}}</label>
                            <h4 class="user_info_txt">{{model.clientName}}</h4>
                        </div>
                        <div class="col-md-3 mb-3">
                            <label class="user_info_header mb-0">{{$t('shared.customerType')}}</label>
                            <h4 class="user_info_txt">{{getCustomerTypeText(model.customerType)}}</h4>
                        </div>
                        <div class="col-md-3 mb-3" v-if="model.customerType !== 3">
                            <label class="user_info_header mb-0"
                                   v-if="model.customerType === 1">{{$t('shared.budgetNumber')}}</label>
                            <label class="user_info_header mb-0"
                                   v-if="model.customerType === 2">{{$t('shared.licenseNumber')}}</label>
                            <label class="user_info_header mb-0"
                                   v-if="model.customerType === 4">{{$t('shared.internationalCommercialRegistrationNumber')}}</label>
                            <h4 class="user_info_txt">{{model.crNumber}}</h4>
                        </div>
                        <div class="col-md-3 mb-3">
                            <label class="user_info_header mb-0">{{$t('shared.representativeName')}}</label>
                            <h4 class="user_info_txt">{{ maskedRepresentativeName }}</h4>
                        </div>
                        <div class="col-md-3 mb-3" v-if="model.customerType === 2 || model.customerType === 3">
                            <label class="user_info_header mb-0">{{$t('shared.enterpriseUnifiedNumber')}}</label>
                            <h4 class="user_info_txt">{{model.enterpriseUnifiedNumber}}</h4>
                        </div>
                        <div class="col-md-3 mb-3">
                            <label class="user_info_header mb-0">{{$t('shared.representativePhoneNumber')}}</label>
                            <h4 class="user_info_txt"><span class="pr-3">+966</span> {{model.representativeMobile}}</h4>
                        </div>
                        <div class="col-md-3 mb-3">
                            <label class="user_info_header mb-0">{{$t('shared.representativeEmail')}}</label>
                            <h4 class="user_info_txt">{{model.representativeEmail}}</h4>
                        </div>
                        <div class="col-md-3 mb-3">
                            <label class="user_info_header mb-0">{{$t('shared.duration')}}</label>
                            <h4 class="user_info_txt">{{model.duration}} {{$t('shared.year')}}</h4>
                        </div>
                        <div class="col-md-3 mb-3" v-if="model.domainName">
                            <label class="user_info_header mb-0">{{$t('shared.domainName')}}</label>
                            <h4 class="user_info_txt">{{model.domainName}}</h4>
                        </div>
                        <div class="col-md-3 mb-3" v-if="model.comment && model.comment.trim()">
                            <label class="user_info_header mb-0">{{$t('shared.comment')}}</label>
                            <h4 class="user_info_txt">{{model.comment}}</h4>
                        </div>             
                        <div class="col-md-3 mb-3" v-if="(model.customerType === 2 || model.customerType === 3) && model.hasTrademark">
                            <label class="user_info_header mb-0">{{ $t('shared.trademarkName') }}</label>
                            <h4 class="user_info_txt">{{ model.trademarkName }}</h4>
                        </div>
                        <div class="col-md-3 mb-3" v-if="(model.customerType === 2 || model.customerType === 3) && model.hasTrademark">
                            <label class="user_info_header mb-0">{{ $t('shared.protectionDateFrom') }}</label>
                            <h4 class="user_info_txt">{{ model.protectionDateFrom }}</h4>
                        </div>
                        <div class="col-md-3 mb-3" v-if="(model.customerType === 2 || model.customerType === 3) && model.hasTrademark">
                            <label class="user_info_header mb-0">{{ $t('shared.protectionDateTo') }}</label>
                            <h4 class="user_info_txt">{{ model.protectionDateTo }}</h4>
                        </div>
                        <div class="col-md-12 mb-3 pl-1">
                            <ul class="user_info_header row">
                                <li style="list-style:none" v-if="model.senderRequestAttachments.length > 0"
                                    v-for="(item, index) in model.senderRequestAttachments" :key="item">
                                    <div class="col-md-12 mb-3">
                                        <label class="user_info_header">{{item.attachmentTypeName}}</label>
                                        <h4 class="user_info_txt">
                                            <span class="badge badge-primary">
                                                <i class="fas fa-paperclip"></i>{{item.fileName}}
                                            </span>
                                        </h4>
                                    </div>
                                </li>
                                <li class="list-group-item" v-if="model.senderRequestAttachments.length == 0">
                                    {{$t('shared.noAttachments')}}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="form-row justify-content-between align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_light" @click="reset" v-if="stepNumber == 1">{{$t('shared.reset')}}</a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-outline-primary px-5 py-2 mx-2" @click="back"
                                    v-if="(stepNumber > 1 && stepNumber != 7)" :disabled="isBackDisabled">
                                {{$t('shared.back')}}
                            </button>
                            <button class="btn btn-primary px-5 py-2" @click="next" :disabled="!isValidStep"
                                v-if="(stepNumber === 1 && model.verificationType == 0)|| (stepNumber > 1 && stepNumber < 6 && stepNumber != 5) || (stepNumber === 1 && model.verificationType == 1 && verified == true)">
                                {{$t('shared.next')}}
                            </button>
                            <button class="btn btn-primary px-5 py-2" @click="verify" :disabled="!isValidStep"
                                    v-if="stepNumber === 1 && model.verificationType == 1 && model.customerType === 3 && verified == false">
                                {{$t('loginPage.verify')}}
                            </button>
                            <button class="btn btn-primary px-5 py-2" v-if="stepNumber == 5 && !aiUnavailable && hasMismatch" @click="showmismatchFoundDialog" :disabled="isReviewDisabled">
                                {{$t('shared.review')}}
                            </button>
                            <button class="btn btn-primary px-5 py-2" v-if="stepNumber == 5 && !aiUnavailable && !hasMismatch" @click="next" :disabled="isReviewDisabled">
                                {{$t('shared.review')}}
                            </button>
                            <button class="btn btn-primary px-5 py-2" v-if="stepNumber == 5 && aiUnavailable" @click="next">
                                {{$t('shared.next')}}
                            </button>
                            <button class="btn btn-primary px-5 py-2" v-if="stepNumber == 6"
                                @click="showsubmitRequestDialog">
                                {{$t('shared.submit')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="submitRequestdialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.addInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hidesubmitRequestDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3">
                        {{$t('shared.addsubmitRequestInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hidesubmitRequestDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="submitRequest">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="showRatingDialog" max-width="550" persistent>
            <v-card style="border-radius: 20px;">
                <v-card-text class="text-center">
                    <p class="mt-3" style="font-size: 20px;">
                        {{$t('shared.ratingService')}}
                    </p>
                    <div class="mb-3">
                        <span v-for="n in 5" :key="n" @click="rating = n" style="cursor: pointer; font-size: 32px;">
                            <i :class="['fa-star', rating >= n ? 'fas' : 'far']"
                                :style="{ color: rating >= n ? 'var(--color-4)' : 'var(--color-4)'}"></i>
                        </span>
                    </div>
                    <v-textarea outlined auto-grow rows="2" class="mb-2" :placeholder="$t('shared.commant')"
                        v-model="reason" :maxlength="30"></v-textarea>
                    <div v-if="reasonRequired && !reason" class="text-danger" style="font-size:13px;">
                        {{$t('shared.reasonRequired')}}</div>
                </v-card-text>
                <v-card-actions class="justify-center pb-4">
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto">
                            <button class="btn btn-success px-5 py-2" @click="submitRating"
                                :disabled="!canSubmit || submitting">{{$t('shared.submit')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="mismatchFounddialog" width="554">
            <v-card>
                <v-card-text class="text-center">
                    <p class="mt-4">
                        {{$t('shared.mismatchFound')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hidemismatchFoundDialog">
                                {{$t('shared.no')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="confirmMismatchContinue">{{$t('shared.yes')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="previousGovernmentWarningDialog" width="554" persistent>
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.previousGovernmentSenderWarningTitle')}}
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3" style="font-weight: 700;">{{ previousGovernmentWarningSenderName }}</p>
                    <p class="mt-3" style="color: #E65100;">
                        {{$t('shared.previousGovernmentSenderWarning')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto">
                            <button class="btn btn-primary px-5 py-2" @click="hidePreviousGovernmentWarningDialog">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>